import { matchPath } from 'react-router-dom';

type TPageRoute = { pathname: string; search: string };

/**
 * Para onde o login pedido pelo pré-chat deve voltar: a página atual, com a
 * query. Nas telas de autenticação, vale o origin que já está na URL (ou
 * nenhum), para não aninhar o login dentro do login.
 */
export default function buildWebchatLoginReturnPath(
  { pathname, search }: TPageRoute,
  authenticationRoutes: string[],
): string | null {
  const isAuthenticationPage = authenticationRoutes.some(
    path => matchPath(pathname, { path }) !== null,
  );

  if (!isAuthenticationPage) return `${pathname}${search}`;

  return new URLSearchParams(search).get('origin') || null;
}
